<div ngbDropdown display="dynamic" placement="bottom-end bottom-start top-end top-start">
    <button
        type="button"
        class="btn btn-outline-primary w-100 text-start d-flex justify-content-between align-items-center"
        ngbDropdownToggle
        [attr.id]="id || null"
        [disabled]="isDisabled"
        (blur)="markAsTouched()">
        <span [class.text-muted]="selectedLabel === undefined">
            {{ selectedLabel ?? placeholder }}
        </span>
        <i class="bi bi-chevron-down"></i>
    </button>
    <div ngbDropdownMenu class="w-100 overflow-y-auto" style="max-height: 300px">
        @for (item of data; track item[0]) {
            <button type="button" ngbDropdownItem (click)="select(item[0])">
                {{ item[1] }}
            </button>
        }
    </div>
</div>
